export default __webpack_public_path__ + "static/dialog-x-close-9595590c1326e3b7f676585ff7b16401.png";